export enum StatoAttoEnum {
    BOZZA = <any>"BOZZA",
    VERIFICA = <any>"VERIFICA",
    ELIMINATO = <any>"ELIMINATO",
    DA_REVISIONARE = <any>"DA_REVISIONARE",
    APPROVATO = <any>"APPROVATO",
    IN_FIRMA = <any>"IN_FIRMA",
    FIRMATO = <any>"FIRMATO",
    PUBBLICATO = <any>"PUBBLICATO",
    VERIFICA_CONTABILE = <any>"VERIFICA_CONTABILE",
    VISTO_CONTABILE = <any>"VISTO_CONTABILE",
    RIFIUTO_CONTABILE = <any>"RIFIUTO_CONTABILE",
    APPROVAZIONE_COLLEGIO = <any>"APPROVAZIONE_COLLEGIO",
    ATTO_OSSERVATO = <any>"ATTO_OSSERVATO",
    RITIRATO = <any>"RITIRATO",
    APPROVATO_DA_NOTIFICARE = <any>"APPROVATO_DA_NOTIFICARE",
    ANNULLATO = <any>"ANNULLATO"
}
